var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { mapGetters } from "vuex";
import { Component, Prop } from 'vue-property-decorator';
import { EBillType, EMessageTypeConfig } from "../../enum/EBillType";
import ELogisticsType from "../../enum/ELogisticsType";
import EOrderFromSystem from "../../enum/EOrderFromSystem";
var BillSubTable = (function (_super) {
    __extends(BillSubTable, _super);
    function BillSubTable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.eLogisticsType = ELogisticsType;
        _this.eOrderFromSystem = EOrderFromSystem;
        _this.eBillType = EBillType;
        return _this;
    }
    BillSubTable.prototype.mounted = function () {
        var _this = this;
        this.tableData.map(function (item) { item.amount = item[EMessageTypeConfig[_this.billType].amountFiled]; });
        console.log(2222, this.type);
    };
    BillSubTable.prototype.lookDetail = function () {
        this.$emit("lookDetail", this.row);
    };
    __decorate([
        Prop({
            type: Array,
            default: []
        })
    ], BillSubTable.prototype, "tableData", void 0);
    __decorate([
        Prop({
            type: Object
        })
    ], BillSubTable.prototype, "row", void 0);
    __decorate([
        Prop({
            type: String,
            default: ""
        })
    ], BillSubTable.prototype, "billType", void 0);
    __decorate([
        Prop({
            type: String,
            default: '200px'
        })
    ], BillSubTable.prototype, "operateLabelWidth", void 0);
    __decorate([
        Prop({
            type: String
        })
    ], BillSubTable.prototype, "type", void 0);
    __decorate([
        Prop({
            type: String,
            default: 'deliver'
        })
    ], BillSubTable.prototype, "scene", void 0);
    __decorate([
        Prop({
            type: Number,
            default: 0
        })
    ], BillSubTable.prototype, "isShowUprice", void 0);
    BillSubTable = __decorate([
        Component({
            computed: __assign({}, mapGetters({
                ediStatus: 'ediStatus',
                openedCodeData: 'openedCodeData',
            }))
        })
    ], BillSubTable);
    return BillSubTable;
}(Vue));
export default BillSubTable;
